
class UserPrefs {
    constructor(Health, Business, Entertainment, General, Science, Sports, Technology) {
        this.Health = Health;
        this.Business = Business;
        this.Entertainment = Entertainment;
        this.General = General;
        this.Science = Science;
        this.Sports = Sports;
        this.Technology = Technology;
    }
}

export default UserPrefs;
